// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BWMa","rootParamsCollapsed":"styles_rootParamsCollapsed__XBW0h","rootPreviewFull":"styles_rootPreviewFull__1Zg4W","loader":"styles_loader__2URWS"};